var _path, _path2, _path3, _path4, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSoftwareDeveloper(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.25,22A12.75,12.75,0,1,0,40,9.25,12.76457,12.76457,0,0,0,27.25,22ZM40,10.75A11.25,11.25,0,1,1,28.75,22,11.26294,11.26294,0,0,1,40,10.75Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.75,52A12.76457,12.76457,0,0,0,52,39.25H28A12.76457,12.76457,0,0,0,15.25,52V72h1.5V52A11.26294,11.26294,0,0,1,28,40.75H52A11.26294,11.26294,0,0,1,63.25,52V72h1.5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48,50.93945l-2.53027,2.53028a.74972.74972,0,0,0,0,1.06054L48,57.06055,49.06055,56l-2-2,2-2Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56,57.06055l2.53027-2.53028a.74972.74972,0,0,0,0-1.06054L56,50.93945,54.93945,52l2,2-2,2Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 45.67544,
    y: 53.24958,
    width: 12.64911,
    height: 1.50085,
    transform: "translate(-15.67274 86.25523) rotate(-71.56505)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSoftwareDeveloper);
export default __webpack_public_path__ + "static/media/icon_software_developer.4e19650b55b5aaffd766a262864bc184.svg";
export { ForwardRef as ReactComponent };